const { href } = window.location;
const { NODE_ENV } = process.env;

const IS_DEVELOPMENT = NODE_ENV === 'development';
const IS_LOCAL_UAT = NODE_ENV === 'production' && (href.includes('localhost') || href.includes('127.0.0.1'));
const IS_UAT = NODE_ENV === 'production' && (href.includes('master--ikonate') ||  href.includes('master.ikonate'));

function getUrl() {
  if (IS_DEVELOPMENT) {
    return 'http://localhost:5000';
  } else if (IS_LOCAL_UAT || IS_UAT) {
    return 'https://ikonate-server.onrender.com';
  } else {
    return 'https://ikonate-server.onrender.com';
  }
}

export const API_URL = getUrl();
export const DOWNLOAD_SVG_URL = `${API_URL}/api/download_svgs_v2`;



// WEBPACK FOOTER //
// ./src/utils/urls.js